import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

const KENT_NODE_POOLS_QUERY_KEY = 'kent-node-pools';

export const getNodePoolsQueryKey = (clusterId?: string) =>
  [KENT_NODE_POOLS_QUERY_KEY, clusterId] as const;

type GetNodePoolsQueryArgs = {
  clusterId: string;
  enabled?: boolean;
};

/** Reusable query options for the node-pools list (also subscribed by the edit dialog's 409 reload). */
export const getNodePoolsQuery = ({
  organizationId,
  clusterId,
}: {
  organizationId: string;
  clusterId: string;
}) =>
  queryOptions({
    queryKey: getNodePoolsQueryKey(clusterId),
    queryFn: async () => {
      const { data } = await apiClient.kent.getNodePools({
        organizationId,
        clusterId,
      });
      return data;
    },
  });

export const useGetNodePoolsQuery = ({
  clusterId,
  enabled,
}: GetNodePoolsQueryArgs) => {
  const { currentOrganization } = useOrganizations();
  const organizationId = currentOrganization?.id;

  return useQuery({
    ...getNodePoolsQuery({ organizationId: organizationId!, clusterId }),
    enabled: !!clusterId && enabled,
  });
};
